export default __webpack_public_path__ + "static/media/srinagar5.7dbc283f.jpg";